'use es6';

export var BOOKING_VIRAL_HUBS_CTA = 'booking-page-signup-visual';
export var THANKYOU_VIRAL_HUBS_CTA = 'thank-you-page-signup-visual';
export var wrongHubSpotDomain = 'www.hubspot.com';
export var wrongHubSpotQADomain = 'www.hubspotqa.com';
export var hubSpotDomain = 'app.hubspot.com';
export var hubSpotQADomain = 'app.hubspotqa.com';